import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from '../context/AuthContext';
import { useNotifications } from '../context/NotificationContext';

const WatchPartyNotificationListener = () => {
  const { user } = useAuth();
  const { addNotification } = useNotifications();
  const socketRef = useRef(null);

  useEffect(() => {
    if (!user) return;

    // Connect to the socket server for global watch party notifications
    // In production: use the same origin (animehouse.app)
    // In development: use localhost:5000 (backend server)
    const socketUrl = process.env.NODE_ENV === 'production' 
      ? window.location.origin 
      : 'http://localhost:5000';

    const socket = io(socketUrl, {
      path: '/socket.io/',
      transports: ['websocket', 'polling'],
      withCredentials: true,
    });

    socketRef.current = socket;

    socket.on('connect', () => {
      console.log('[WatchPartyNotifications] Connected to socket server');
      // Join a global watch party notifications room
      socket.emit('join-watch-party-notifications', { userId: user.id });
    });

    // Listen for watch party start events
    socket.on('watch-party-started', (data) => {
      const { partyId, title, hostUsername } = data;

      addNotification({
        type: 'watch-party',
        title: ' Watch Party Started!',
        message: `${hostUsername || 'Someone'} started "${title}"`,
        subtitle: 'Click to join the party',
        link: `/watch-party/${partyId}`,
        duration: 7000, // 7 seconds
      });
    });

    // Listen for watch party invites
    socket.on('watch-party-invite', (data) => {
      const { partyId, title, hostUsername } = data;

      addNotification({
        type: 'watch-party',
        title: 'You\'re invited!',
        message: `${hostUsername} invited you to watch "${title}"`,
        subtitle: 'Click to join',
        link: `/watch-party/${partyId}`,
        duration: 10000, // 10 seconds
      });
    });

    socket.on('disconnect', () => {
      console.log('[WatchPartyNotifications] Disconnected from socket server');
    });

    socket.on('error', (error) => {
      console.error('[WatchPartyNotifications] Socket error:', error);
    });

    return () => {
      console.log('[WatchPartyNotifications] Cleaning up socket connection');
      socket.disconnect();
    };
  }, [user, addNotification]);

  return null; // This is a listener component, no UI
};

export default WatchPartyNotificationListener;
